import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, MenuItem, Select, ListItemText, Tooltip } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { collection, getDocs, query, where, and } from 'firebase/firestore';
import { firestore } from '../firebase.js';
import dayjs from 'dayjs';
import Theme from "../components/theme";
import { ResourceCard } from "../components/ResourceCard";
import useScrollToTop from '../components/useScrollToTop';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
//import {styled} from '@mui/material/styles';
//import LoadingIcon from "../components/LoadingIcon";


function ResourcesPage(props) {
  const initResources = useRef(props.resources);
  const [stateChanges, setStateChanges] = useState(0);
  const [notTimeFilteredResources, setNotTimeFilteredResources] = useState([]);
  const [filteredResources, setFilteredResources] = useState(null);
  const [searchedResources, setSearchedResources] = useState(null);
  const isBetween = require("dayjs/plugin/isBetween");
  dayjs.extend(isBetween);
  useScrollToTop();

  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "All"];
  const resourceTypes = ["Food Pantry", "Shelter", "Medical", "Financial", "Family Help", "Clothing", "Education", "Any"];

  useEffect(() => {
    initResources.current = props.resources;
  }, [props]);


  useEffect(() => { },
    [stateChanges])

  useEffect(() => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const getFilteredResourcesByDayAndType = async (day, type) => {
      const q = query(collection(firestore, "diffTimeResources"), and(where("type", "==", type), where(`openTimes.${day}`, "!=", [])));
      let querySnapshot = await getDocs(q);
      querySnapshot = convertDocToUseable(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      setNotTimeFilteredResources(querySnapshot);
    }
    const getFilteredResourcesByDayAndTypeForOvernightTime = async (day, type) => {
      const q = query(collection(firestore, "diffTimeResources"), and(where("type", "==", type), where(`openTimes.${day}`, "!=", [])));
      const q2 = query(collection(firestore, "diffTimeResources"), and(where("type", "==", type), where(`openTimes.${days[(days.indexOf(props.day) - 1 + 7) % 7]}`, "!=", [])));
      let querySnapshot = await getDocs(q);
      let querySnapshot1 = await getDocs(q2);
      querySnapshot = convertDocToUseable(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      querySnapshot1 = convertDocToUseable(querySnapshot1.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      let indices = [];
        for(let i = 0; i < querySnapshot.length; i++) {
          for(let j = 0; j < querySnapshot1.length; j++) {
            if(querySnapshot[i].id === querySnapshot1[j].id) {
              indices.push(j);
            }
          }
        }
        indices.sort((a, b) => b - a);
        indices.forEach((val) => {querySnapshot1.splice(val, 1)});
      setNotTimeFilteredResources(querySnapshot.concat(querySnapshot1));
    }
    const getFilteredResourcesByDay = async (day) => {
      const q = query(collection(firestore, "diffTimeResources"), where(`openTimes.${day}`, "!=", []));
      try {
        const querySnapshot = await getDocs(q);
        let querySnapshot1 = convertDocToUseable(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setNotTimeFilteredResources(querySnapshot1);
      }
      catch (error) {
        console.log(error);
      }
    }
    const getFilteredResourcesByDayForOvernightTime = async (day) => {      
      const q = query(collection(firestore, "diffTimeResources"), where(`openTimes.${day}`, "!=", []));
      const q1 = query(collection(firestore, "diffTimeResources"), where(`openTimes.${days[(days.indexOf(props.day) - 1 + 7) % 7]}`, "!=", []));
      try {
        let querySnapshot = await getDocs(q);
        let querySnapshot1 = await getDocs(q1);
        
        querySnapshot = convertDocToUseable(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        querySnapshot1 = convertDocToUseable(querySnapshot1.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        let indices = [];
        for(let i = 0; i < querySnapshot.length; i++) {
          for(let j = 0; j < querySnapshot1.length; j++) {
            if(querySnapshot[i].name === querySnapshot1[j].name) {
              indices.push(j);
            }
          }
        }
        indices.sort((a, b) => b - a);
        indices.forEach((val) => {querySnapshot1.splice(val, 1)});
        setNotTimeFilteredResources(querySnapshot.concat(querySnapshot1));
      }
      catch (error) {
        console.log(error);
      }
    }
    const getFilteredResourcesByType = async (type) => {
      const q = query(collection(firestore, "diffTimeResources"), where("type", "==", type));
      let querySnapshot = await getDocs(q);
      querySnapshot = convertDocToUseable(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      setNotTimeFilteredResources(querySnapshot);
    }
    if (props.type === "Any" && props.day === "All") {
      if (initResources !== undefined) {
        setFilteredResources(initResources.current);
        setNotTimeFilteredResources(initResources.current);
      }
    }
    else if (props.type === "Any") {
      if(props.time === null || props.time === undefined){
        getFilteredResourcesByDay(props.day);
      } else {
        getFilteredResourcesByDayForOvernightTime(props.day);
      }
    }
    else if (props.day === "All") {
      getFilteredResourcesByType(props.type);
    }
    else if (props.day !== "All" && props.type !== "Any") {
      if(props.time === null || props.time === undefined){
        getFilteredResourcesByDayAndType(props.day, props.type);
      } else {
        getFilteredResourcesByDayAndTypeForOvernightTime(props.day, props.type);
      }
    }
  

  }, [props.day, props.time, props.type, stateChanges, props.resources]);

  useEffect(() => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let filtered = notTimeFilteredResources;
    if (props.time === null || props.day === "All" || !props.time.isValid()) {
      if (filtered.length === 0) {
        setFilteredResources(Array(1).fill("empty"));
      }
      else {
        setFilteredResources(JSON.parse(JSON.stringify(filtered)));
      }
    }
    else if(notTimeFilteredResources !== undefined) {
      const time = dayjs(`2025-01-${days.indexOf(props.day) + 5}T${props.time.format("HH:mm:ss")}`)
      let discardIndices = [];
      for (let j = 0; j < notTimeFilteredResources.length; j++) {
        let discardResource = true;
        for (let i = 0; i < notTimeFilteredResources[j].openTimes[props.day].length; i+=2) {
          if (time.isBetween(dayjs(notTimeFilteredResources[j].openTimes[props.day][i]), dayjs(notTimeFilteredResources[j].openTimes[props.day][i + 1]))) {
            discardResource = false;
          }
        }
        for (let i = 0; i < notTimeFilteredResources[j].openTimes[days[(days.indexOf(props.day) - 1 + 7) % 7]].length; i+=2) {
          if (time.isBetween(dayjs(notTimeFilteredResources[j].openTimes[days[(days.indexOf(props.day) - 1 + 7) % 7]][i]), dayjs(notTimeFilteredResources[j].openTimes[days[(days.indexOf(props.day) - 1 + 7) % 7]][i + 1]))) {
            discardResource = false;
          }
        }
        if (discardResource) {
          discardIndices.push(j);
        }
      }
      discardIndices.sort((a, b) => b - a);
      for (let i = 0; i < discardIndices.length; i++) {
        filtered.splice(discardIndices[i], 1);
      }
      if (filtered.length === 0) {
        setFilteredResources(Array(1).fill("empty"));
      }
      else
        setFilteredResources(JSON.parse(JSON.stringify(filtered)));
    }
  }, [notTimeFilteredResources, props.day, props.time, props.type])

  useEffect(() => {
    if (filteredResources !== null && filteredResources !== undefined && props.search !== null && props.search !== undefined) {
      if (filteredResources[0] === 'empty') {
        setSearchedResources(Array(1).fill("empty"))
      }
      else {
        if (props.search === '') {
          setSearchedResources(JSON.parse(JSON.stringify(filteredResources)));
        }
        else {
        let filtered = JSON.parse(JSON.stringify(filteredResources));
          for (let i = 0; i < filtered.length; i++) {
            if (!filtered[i].name.toLowerCase().includes(props.search.toLowerCase())) {
              filtered.splice(i, 1);
              i--;
            }
          }
          if(filtered.length === 0)
            setSearchedResources(Array(1).fill("empty"))
          else
            setSearchedResources(filtered);
        } 
      }
    }
  }, [filteredResources, props.search])

  const convertDocToUseable = (data) => {
    let dataCopy = data
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    for (let i = 0; i < 7; i++) {
      for (const key in data.openTimes) {
        if (daysOfWeek[i] === key) {
          dataCopy.openTimes[key] = data.openTimes[key].map((e) => dayjs(e))
        }
      }
    }
    return dataCopy;
  }

  return (
    <>
      <Helmet>
        <title>Homeless Resources - Food, Shelter, Medical & Financial Help</title>
        <meta name="description" content="Find essential resources including food pantries, shelters, and other services available near you." />
      </Helmet>
      <Theme>
        <Box textAlign="center" width="100%">
          <Typography color="primary" variant="h3">Resources</Typography>
          <Typography color="primary" variant="h5" padding="3vh">Click on any of the resources below for more info (You need to pick a day to filter by time)</Typography>
          <div className="flex-col mx-auto items-center bg-blue w-[40vw] max-w-[600px]">
            <div className="flex justify-center w-full mb-2 lg:mt-6 lg:mb-10">
              <div className="flex flex-col w-full items-start">
                <Typography>Search for a Resource</Typography>
                <Autocomplete
                  freeSolo
                  value={props.search}
                  onInputChange={(event, value) => {
                    props.setSearch(value);
                  }}
                  className="w-full"
                  options={(initResources.current !== null && initResources.current !== undefined) ? initResources.current.map((resource) => { return resource.name }) : Array(0)}
                  renderInput={(params) => <TextField {...params} className="w-full" placeholder="Search" />}
                />
              </div>
            </div>
            <div className="flex justify-evenly flex-col items-center lg:flex-row lg:justify-between lg:gap-20 w-full"> {/*changed*/}
              <Box className="w-4/5 lg:w-36"> {/*changed*/} {/*changed*/}
                <Typography className="text-center lg:text-left">Resource Type</Typography> {/*changed*/}
                <Select
                  defaultValue=""
                  value={props.type}
                  onChange={(event) => { setStateChanges(currValue => currValue + 1); props.setType(event.target.value) }}
                  sx={{ width: '100%', mb: 2 }}
                >
                  {resourceTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      <ListItemText primary={type} />
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box className="w-4/5 lg:w-36"> {/*changed*/}
                <Typography className="text-center lg:text-left">Day of Week</Typography> {/*changed*/}
                <Select
                  defaultValue=""
                  value={props.day}
                  onChange={(event) => { props.setDay(event.target.value); setStateChanges(currValue => currValue + 1); if (event.target.value === "All") { props.setTime(null) } }}
                  sx={{ width: '100%', mb: 2 }}
                >
                  {days.map((day) => (
                    <MenuItem key={day} value={day}>
                      <ListItemText primary={day} />
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box className={`w-64 lg:w-36 ${props.day.toLowerCase() === 'all' ? 'invisible' : 'visible'}`}> {/*changed*/}
                <Typography className="text-center lg:text-left">Time</Typography> {/*changed*/}
                <Tooltip title={(props.day.toLowerCase() === "all") ? "Pick a day to filter by time." : ""}>
                  <span>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        placeholder="Time"
                        label=" "
                        sx={{ width: '100%', mb: 2 }}
                        value={props.day !== "All" ? props.time : null}
                        defaultValue={null}
                        onChange={(value) => { setStateChanges(currValue => currValue + 1); props.setTime(value) }}
                        disabled={props.day === "All"}
                        fullWidth
                      />
                    </LocalizationProvider>
                  </span>
                </Tooltip>
              </Box>
            </div>
          </div>
          <Box className="flex flex-col items-center lg:flex-row lg:justify-center lg:gap-10"> {/*changed*/}
            <button className="bg-button_yellow text-black py-2 px-4 min-w-[260px] rounded-lg font-semibold hover:bg-opacity-60 flex items-center justify-center shadow-md"
              onClick={() => {
                props.setTime(null);
                props.setDay("All");
                props.setType("Any");
                if (initResources !== undefined) {
                  setFilteredResources(JSON.parse(JSON.stringify(initResources.current)));
                  setNotTimeFilteredResources(JSON.parse(JSON.stringify(initResources.current)));
                }
                props.setSearch('');
                setStateChanges(currValue => currValue + 1);
              }}>
              Clear Filter
            </button>
          </Box>

          {(props.search !== null && props.search !== undefined && props.search === '') ?
            (props.type.toLowerCase() === "any" && props.day.toLowerCase() === "all") ?
              <Typography sx={{ fontSize: "1.2rem", mt: 2, mb: 2, paddingLeft: "50px", paddingRight:"50px" }}>No filter applied.</Typography> :
              <Typography sx={{ fontSize: "1.2rem", mt: 2, mb: 2, paddingLeft: "50px", paddingRight:"50px"}}>Filtering for {<strong>{props.type.toLowerCase() === "any" ? "all resource types" : `${props.type} type resources`}</strong>} open on <strong>{props.day.toLowerCase() === "all" ? "any day" : props.day}</strong> at<strong>{(props.time !== null && props.time.isValid()) ? ` ${props.time.format("hh:mm a")}.` : " any time."}</strong></Typography>
            :
            (props.type.toLowerCase() === "any" && props.day.toLowerCase() === "all") ?
              <Typography sx={{ fontSize: "1.2rem", mt: 2, mb: 2 , paddingLeft: "50px", paddingRight:"50px"}}>{`Filtering for resources with `}<strong>{props.search}</strong>{` in the name.`}</Typography> :
              <Typography sx={{ fontSize: "1.2rem", mt: 2, mb: 2 , paddingLeft: "50px", paddingRight:"50px"}}>Filtering for {<strong>{props.type.toLowerCase() === "any" ? "all resource types" : `${props.type} type resources`}</strong>} open on <strong>{props.day.toLowerCase() === "all" ? "any day" : props.day}</strong> at<strong>{(props.time !== null && props.time.isValid()) ? ` ${props.time.format("hh:mm a")} ` : " any time "}</strong>{"with "}<strong>{props.search}</strong>{` in the name.`}</Typography>
          }

          <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly", gap: "2vw", marginX: "5vw" }}>
            {searchedResources === null || searchedResources.length === 0 ? (
              <CircularProgress />
            ) : searchedResources[0] === 'empty' ? (
              <Typography variant="h5" sx={{ mt: "50px" }}>No Available Resources</Typography>
            ) : (
              searchedResources.map((location) => (
                <ResourceCard key={location.id} location={location} dayFilterOn={props.day !== "All"} />
              ))
            )}
          </Box>
        </Box>
      </Theme>

    </>
  );
}

export default ResourcesPage;
